import React from 'react';

import { PrimaryButton } from '@components/Button/variants';

interface FooterProps {
  isSubscriber: boolean;
  subscribePromoUrl: string;
}

const Footer = ({ isSubscriber, subscribePromoUrl }: FooterProps) => {
  return (
    <div className="mt-24 flex flex-col items-center justify-center px-16 lg:px-0">
      <div className="text-center font-suisse-works text-headline-lg font-medium text-primary-magenta md:text-headline-xl">
        Read The Information first…
      </div>
      <div className="text-center font-suisse-works text-headline-lg font-medium">
        or <span className="italic">them</span> later
      </div>
      <div className="text-style body-lg mb-32 text-center font-suisse-neue font-normal text-[#6d686e] sm:max-w-[520px]">
        The Information is where you go to get the most important news about technology and business
        first.
      </div>
      {!isSubscriber && (
        <PrimaryButton
          className="mt-8 w-[240px] font-suisse-intl !text-body-lg !capitalize"
          as="link"
          href={subscribePromoUrl}
        >
          Subscribe
        </PrimaryButton>
      )}
    </div>
  );
};

export default Footer;
